import React from 'react'
import Nom035 from "../components/lineamientos/Nom035";

export const Nom035Page = () => {
    return (
       <Nom035/>
    )
}
